<template>
  <v-container fill-height fluid class="text-center" style="background-color: #eae8e0">
    <v-row align="center">
      <v-spacer></v-spacer>
      <v-col cols="12" sm="9" md="6" lg="6" xl="4" align="center" class="login">
        <v-card class="login-card">
          <logo-login />
          <div class="login-discription">{{ $t('message.common_label_login_title') }}</div>
          <v-text-field
            class="id-form"
            @keydown.enter="login"
            v-model="email"
            :label="$t('message.common_label_login_id')"
            single-line
            outlined
          ></v-text-field>
          <v-text-field
            class="pass-form"
            @keydown.enter="login"
            v-model="password"
            type="password"
            :label="$t('message.common_label_password')"
            single-line
            outlined
          ></v-text-field>
          <v-btn @click="login" depressed>{{ $t('message.common_label_login') }}</v-btn>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import ElementUI from 'element-ui'
import logoLogin from '../assets/logoLogin.svg'

export default {
  name: 'Login',
  components: { logoLogin },
  data() {
    return {
      email: '',
      password: ''
    }
  },
  created() {
    this.resetAllStates()
  },
  methods: {
    async login() {
      try {
        await firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        const token = await firebase.auth().currentUser.getIdToken(true)
        localStorage.setItem('token', token)
        await this.$store.dispatch('licensees/getLicensee')
        const licenseeType = this.$store.getters['licensees/licenseeType']
        let path = '/register'
        if (licenseeType == "LICENSEE") {
          path = '/'
        }
        this.$router.push(path).catch(() => {})
      } catch {
        const title = navigator.language === 'ja' ? 'エラー' : 'Error'
        const message = navigator.language === 'ja' ? 'ログインに失敗しました。' : 'Failed to login.'
        ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
      }
    },
    resetAllStates() {
      this.$store.dispatch('common/clearState')
      this.$store.dispatch('contracts/clearState')
      this.$store.dispatch('invoices/clearState')
      this.$store.dispatch('licensees/clearState')
      this.$store.dispatch('platforms/clearState')
      this.$store.dispatch('restaurants/clearState')
      this.$store.dispatch('sales/clearState')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-title {
  font-family: Helvetica;
  font-style: normal;
  font-weight: bold;
  font-size: 61.4483px;
  line-height: 71px;
  color: #000000;
}
.login-subtitle {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 300;
  font-size: 22.7586px;
  line-height: 26px;
  color: #000000;
}
.login-discription {
  margin: 43px 0;
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: #666666;
}
.login-card {
  padding: 75px;
}
.login ::v-deep .v-btn {
  width: 200px;
  background: #9b8616 !important;
  border-radius: 8px;
  font-family: Hiragino Kaku Gothic Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 16px !important;
  line-height: 24px;
  color: #fff;
  margin-top: 43px;
}

.login ::v-deep .v-text-field {
  width: 290px;
  height: 53px;
  background-color: #fff;
  border-radius: 6px;
}

.login ::v-deep .pass-form {
  margin-top: 18px;
}
</style>
